import React from "react";
import { Mercedes } from "./Mercedes";
import { Delos } from "./Delos";
import { USTA } from "./USTA";
import { Stories } from "./Stories";
import { BackButton } from "../NavButton";

export const ThreeStories = ({ updateActiveSlide, active, getSlideNumber }) => {
  return (
    <div id="three-stories" className={`${active ? "active " : ""}item`}>
      <div className="fill three-stories-fill" style={{ display: "flex", flexDirection: "column" }}>
        <div className="three-stories-back">
          <BackButton onClick={() => updateActiveSlide(getSlideNumber(Stories))} />
        </div>
        <div className="three-stories-row">
          {[
            { id: "mercedes-story", img: "/images/mercedes-stories2.png", label: "mercedes", target: Mercedes },
            { id: "delos-story",    img: "/images/delos-stories2.png",    label: "delos",    target: Delos },
            { id: "usta-story",     img: "/images/tennis-stories.jpg",    label: "usta",     target: USTA },
          ].map(({ id, img, label, target }) => (
            <div
              key={id}
              id={id}
              className="slide-link pick5-panel three-stories-panel"
              style={{ backgroundImage: `url('${img}')` }}
              onClick={() => updateActiveSlide(getSlideNumber(target))}
            >
              <h2 className="museo-sans-100 stories-panel-title" style={{ fontSize: "2em", margin: 0 }}>
                {label}
              </h2>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
ThreeStories.slideName = "ThreeStories";
ThreeStories.pathname = "/three-stories";
